import React, { useState } from "react";
import { toast } from "sonner";
import { assetApi } from "@/lib/entities";
import { apiError } from "@/lib/errors";
import { StatusPill } from "@/components/Chips";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const STATUSES = [
  "available", "inquiry", "soft_hold", "first_hold", "second_hold",
  "contract_pending", "booked", "touring", "maintenance", "shop",
  "owner_use", "out_of_service", "inactive",
];

export const StatusChangeDialog = ({ open, asset, onClose, onDone }) => {
  const [to, setTo] = useState("available");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await assetApi.changeStatus(asset.id, to, reason || null);
      toast.success(`Status changed to ${to}`);
      onDone();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="status-change-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Change Status</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 text-[13px]">
          <div className="text-[12px] text-steel">
            Current: <StatusPill status={asset.operational_status} />
          </div>
          <label className="block">
            <div className="text-[11.5px] font-medium uppercase tracking-wide text-steel mb-1">
              Target Status
            </div>
            <select
              data-testid="sc-to-status"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              className="w-full border border-coach-silver rounded-sm px-2.5 py-1.5 bg-white"
            >
              {STATUSES.map((s) => (
                <option key={s} value={s}>{s.replace(/_/g, " ")}</option>
              ))}
            </select>
          </label>
          <label className="block">
            <div className="text-[11.5px] font-medium uppercase tracking-wide text-steel mb-1">
              Reason
            </div>
            <textarea
              data-testid="sc-reason"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="e.g. brake service"
              className="w-full border border-coach-silver rounded-sm px-2.5 py-1.5"
            />
          </label>
          <DialogFooter className="pt-2">
            <button type="button" onClick={onClose} className="px-3 py-1.5 text-[12.5px] text-steel border border-coach-silver rounded-sm">
              Cancel
            </button>
            <button data-testid="sc-submit" disabled={busy} className="px-4 py-1.5 text-[12.5px] font-medium bg-coach-blue text-white rounded-sm disabled:opacity-60">
              {busy ? "Changing…" : "Change Status"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
